import KeepIcon from '@mui/icons-material/Done';
import PropTypes from 'prop-types';
import React from 'react';
import RejectIcon from '@mui/icons-material/Close';
import {Box} from '@mui/material';

export const YayOrNay = ({include, onClick, ...extras}) => {
  let style = {
    borderRadius: 24,
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid 2px white',
    color: 'white',
    zIndex: 10,
    transition: 'background-color 400ms',
    '& *': {
      opacity: 0,
      transition: 'opacity 450ms',
    },
  };

  if (include === true) {
    style = Object.assign(style, {
      backgroundColor: 'success.main',
      '& *': {
        opacity: 1,
        transition: 'opacity 450ms',
      },
    });
  } else if (include === false) {
    style = Object.assign(style, {
      backgroundColor: 'error.main',
      '& *': {
        opacity: 1,
        transition: 'opacity 450ms',
      },
    });
  } else {
    style = Object.assign(style, {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    });
  }

  if (onClick) {
    style.cursor = 'pointer';
  }

  return (
    <Box onClick={onClick} sx={style} {...extras}>
      {include === true && <KeepIcon />}
      {include === false && <RejectIcon />}
    </Box>
  );
};

YayOrNay.propTypes = {
  include: PropTypes.bool,
  onClick: PropTypes.func,
};
